<template>
  <aside id="output"></aside>
</template>